import isFunction from 'lodash/isFunction';
const ExpandedRow = props => {
    const { isExpanded, children = null, columns, record, lock } = props;
    if (isFunction(children)) {
        const child = children(columns, record, isExpanded, lock);
        if (child) {
            return child;
        }
    }
    return children;
};
export default ExpandedRow;
